const noticeProductToastMsg = {
  /**
   *  [상품 공지사항 리스트] 상품 공지사항 리스트 가져오기
   */
  GET_NOTICE_PRODUCT_LIST_REQUEST_SUCCESS: '상품 공지사항 리스트 가져오기 성공',
  GET_NOTICE_PRODUCT_LIST_REQUEST_ERROR: '상품 공지사항 리스트 가져오기 실패',

  /**
   *  [상품 공지사항 리스트] 상품 공지사항 리스트 가져오기
   */
  GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 공지사항 리스트 엑셀 다운로드 성공',
  GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 공지사항 리스트 엑셀 다운로드 실패',

  /**
   *  [상품 공지사항 리스트] 공지사항 삭제 요청하기
   */
  DELETE_NOTICE_PRODUCT_REQUEST_SUCCESS: '상품 공지사항 삭제 성공',
  DELETE_NOTICE_PRODUCT_REQUEST_ERROR: '상품 공지사항 삭제 실패',

  /**
   *  [상품 공지사항 상세] 상품 공지사항 상세 가져오기
   */
  GET_NOTICE_PRODUCT_INFO_REQUEST_SUCCESS: '상품 공지사항 상세 가져오기 성공',
  GET_NOTICE_PRODUCT_INFO_REQUEST_ERROR: '상품 공지사항 상세 가져오기 실패',

  /**
   *  [상품 공지사항 상세] 상품 공지사항에 등록된 상품 가져오기
   */
  GET_NOTICE_PRODUCT_ITEM_INFO_REQUEST_SUCCESS: '상품 공지사항에 등록된 상품 가져오기 성공',
  GET_NOTICE_PRODUCT_ITEM_INFO_REQUEST_ERROR: '상품 공지사항에 등록된 상품 가져오기 실패',
};

export default noticeProductToastMsg;
